import componentize from '../utils/componentize';
import $ from 'jquery';
/* global window */
/* global document */

export default function () {
    // var $story = $('a.anchor');
    // var $rank = $story.find('.rank');
    // var $numReading = $story.find('.number-reading');

    // console.log($story.innerHeight())


    componentize({
        query: 'a.anchor',

        attachedCallback: function () {
            //this.addEventListener('mouseenter', this.inHandle.bind(this));
            //this.addEventListener('mouseleave', this.outHandle.bind(this));
        },

        inHandle: function () {
            var $container = $(this).find('.story-data');
            var $rank = $container.find('.rank');
            var $numReading = $container.find('.number-reading');

            $rank.hide();
            $numReading.fadeToggle();
        },

        outHandle: function () {
            var $container = $(this).find('.story-data');
            var $rank = $container.find('.rank');
            var $numReading = $container.find('.number-reading');

            $numReading.hide();
            $rank.fadeToggle();
        }
    });
}
